<template>
    <div class="container-fluid">
        <div class="h2 mb-2">
            {{ title }}
        </div>

        <div v-for="(contract, index) in contractsWithNotCollapse" :key="contract.msisdn">
            <div class="d-none d-lg-block">
                <div class="row mb-2">
                    <zone-contracts-desktop :contract="contract" :index="index" />
                </div>
            </div>
            <div class="d-block d-lg-none">
                <div class="d-md-none">
                    <div class="row mb-1">
                        <zone-contracts-mobile :contract="contract" :index="index" />
                    </div>
                </div>
                <div class="d-none d-md-block">
                    <div class="row mb-1">
                        <zone-contracts-tablet :contract="contract" :index="index" />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="contractsWithCollapse.length > 0">
            <div
                id="contracts-collapsed-block"
                class="collapse"
                role="region"
                aria-labelledby="collapsed-contract-header"
            >
                <div v-for="(contract, index) in contractsWithCollapse" :key="contract.msisdn">
                    <div class="d-none d-lg-block">
                        <div class="row mb-2">
                            <zone-contracts-desktop :contract="contract" :index="index" />
                        </div>
                    </div>
                    <div class="d-block d-lg-none">
                        <div class="d-md-none">
                            <div class="row mb-1">
                                <zone-contracts-mobile :contract="contract" :index="index" />
                            </div>
                        </div>
                        <div class="d-none d-md-block">
                            <div class="row mb-1">
                                <zone-contracts-tablet :contract="contract" :index="index" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <button
                    id="collapsed-contract-header"
                    type="button"
                    class="btn btn-secondary"
                    data-bs-toggle="collapse"
                    data-bs-target="#contracts-collapsed-block"
                    aria-controls="contracts-collapsed-block"
                    @click="clickHandler"
                >
                    {{ buttonLabel }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>

import ZoneContractsMobile from "./ZoneContractsMobile.vue";
import ZoneContractsTablet from "./ZoneContractsTablet.vue";
import ZoneContractsDesktop from "./ZoneContractsDesktop.vue";

export default {
    components: {ZoneContractsDesktop, ZoneContractsTablet, ZoneContractsMobile},
    props: {
        title: {
            type: String,
            required: true
        },
        contractsWithNotCollapse: {
            type: Array,
            required: true
        },
        contractsWithCollapse: {
            type: Array,
            required: true
        },
        showMoreContractsButtonLabel: {
            type: String,
            required: true
        },
        showLessContractsButtonLabel: {
            type: String,
            required: true
        }
    },
    data: function () {
        return {
            internalIsCollapsed: false,
            buttonLabel:  this.showMoreContractsButtonLabel,
        }
    },
    methods: {
        clickHandler: function () {
            if (this.internalIsCollapsed) {
                this.buttonLabel = this.showMoreContractsButtonLabel;
            } else {
                this.buttonLabel = this.showLessContractsButtonLabel;
            }
            this.internalIsCollapsed = !this.internalIsCollapsed
        },
    },
}
</script>

